import { parseISO, isValid, format } from 'date-fns';
import { DateTime } from 'luxon';

export const formatToString = (date) => {
  if (!date) return;
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, 'PP');
  }
  return '';
};

export const formatToStringComplete = (date) => {
  if (!date) return;
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return format(parsedDate, 'MMMM d, yyy');
  }
  return '';
};

export const fmt = (dt) => (dt ? DateTime.fromISO(dt).toFormat("yyyy-LL-dd'T'HH:mm:ss") : null);
